var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1758 21.7422H1.34766C0.602762 21.7422 0 22.3449 0 23.0898V41.957C0 44.1864 1.81359 46 4.04297 46H28.4805C30.7099 46 32.5234 44.1864 32.5234 41.957V23.0898C32.5234 22.3449 31.9207 21.7422 31.1758 21.7422ZM24.2578 29.8281C24.2578 34.287 20.6307 37.9141 16.1719 37.9141C11.713 37.9141 8.08594 34.287 8.08594 29.8281V28.4805C8.08594 27.7356 8.6887 27.1328 9.43359 27.1328C10.1785 27.1328 10.7812 27.7356 10.7812 28.4805V29.8281C10.7812 32.8011 13.1989 35.2188 16.1719 35.2188C19.1449 35.2188 21.5625 32.8011 21.5625 29.8281V28.4805C21.5625 27.7356 22.1653 27.1328 22.9102 27.1328C23.6551 27.1328 24.2578 27.7356 24.2578 28.4805V29.8281Z",
    fill: "url(#paint0_linear_0_3714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6523 10.9609H37.7344V8.08594C37.7344 3.62708 34.1073 0 29.6484 0C25.1896 0 21.5625 3.62708 21.5625 8.08594V10.9609H14.6445C13.8996 10.9609 13.2969 11.5637 13.2969 12.3086V19.0469H31.1758C33.4052 19.0469 35.2188 20.8605 35.2188 23.0898V41.957C35.2188 43.4797 34.6918 44.8703 33.8367 46H41.957C44.1864 46 46 44.1864 46 41.957V12.3086C46 11.5637 45.3972 10.9609 44.6523 10.9609ZM35.0391 10.9609H24.2578V8.08594C24.2578 5.11292 26.6754 2.69531 29.6484 2.69531C32.6215 2.69531 35.0391 5.11292 35.0391 8.08594V10.9609Z",
    fill: "url(#paint1_linear_0_3714)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3714",
    x1: 2.20772,
    y1: 19.3597,
    x2: 34.6499,
    y2: 22.3297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_3714",
    x1: 15.5168,
    y1: -4.51786,
    x2: 48.3343,
    y2: -2.92481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.a75836277720339e5917b6686d988026.svg";
export { ForwardRef as ReactComponent };